import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/finance/stakeholders`;

/** role: clientes | proveedores | honorarios | colaboradores */
export const getStakeholders = async (role) =>
  apiClient(`${BASE}?role=${encodeURIComponent(role)}`, { timeoutMs: 60000 });

export const getStakeholderDetail = async ({ role, rut = '', name = '' }) => {
  const params = new URLSearchParams({ role, rut: rut || '', name: name || '' });
  return apiClient(`${BASE}/detail?${params.toString()}`, { timeoutMs: 60000 });
};
